/* Section: faq — accordion behavior with a11y. */
(() => {
  const section = document.querySelector('[data-section="faq"]');
  if (!section) return;

  const items = section.querySelectorAll('.faq__item');

  items.forEach((item) => {
    const btn = item.querySelector('.faq__q');
    const panel = item.querySelector('.faq__a');
    if (!btn || !panel) return;

    const setOpen = (open) => {
      item.classList.toggle('faq__item--open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    btn.addEventListener('click', () => {
      const willOpen = !item.classList.contains('faq__item--open');
      // close all others (single-open accordion)
      items.forEach((other) => {
        if (other !== item) {
          other.classList.remove('faq__item--open');
          other.querySelector('.faq__q')?.setAttribute('aria-expanded', 'false');
          other.querySelector('.faq__a')?.setAttribute('aria-hidden', 'true');
        }
      });
      setOpen(willOpen);
    });
  });
})();
